import styled from "styled-components";

export const UserPath = styled.div`
  width: auto;
  height: 90px;
  display: flex;
  align-items: center;
  gap: 10px;
  /* border: 1px solid; */

  div:first-child {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  div:last-child {
    width: auto;
    height: 80px;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    flex-direction: column;
    /* border: 1px solid; */

    p {
      font-size: 16px;
      color: black;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    span {
      font-size: 16px;
    }
  }
`;
